var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['static-field', ..._vm.variantClassList]},[_c('span',{staticClass:"static-field__label"},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.labelValue)+" ")]})],2),_c('span',{staticClass:"static-field__value"},[_vm._t("value",function(){return [_vm._v(" "+_vm._s(_vm.value)+" ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }